export default "__VITE_ASSET__e32d81d4__"